export default "__VITE_ASSET__C08k8I6l__"